<template>
	<!-- wrapper -->
	<div class="" style="width: 100%;height: 100%;overflow-x: hidden;">
		<el-row :gutter="24">
			<el-col :span="24">
				<el-page-header style="background-color: #FFFFFF00;" @back="goBack" content="会议直播"></el-page-header>
			</el-col>
		</el-row>
		<!-- <video ref="videoElement" controls autoplay class="video"></video> -->
		<el-card class="box-card">
			<!-- <div slot="header" class="clearfix" v-if="userInfo.type !== 'ADMIN'">
				<el-page-header @back="goBack" content="会议直播"> </el-page-header>
			</div> -->
			<div class="live-container">
				<div class="flex align-center justify-between" style="width: 100%;">
					<div class="title">{{ meetingName }}</div>
					<div class="" style="margin-right: 30px;">
						<el-popover v-if="meetingUserInfo.name && meetingUserInfo.idCard" trigger="hover"
							placement="bottom-start" popper-class="menu-popover">
							<div class="popup_view" style="">
								<img style="width: 100%;height: 100%;" src="../../assets/img/personal-bg2.png" />
								<div class="flex align-center justify-between popup_view_name">
									<div class="popup_view_name_text_1">
										{{ meetingUserInfo.name }}
									</div>
									<div class="flex align-center justify-center"
										style="width: 72px;height: 35px;background-color: #00C700;border-radius: 20px 0px 0px 20px;margin-right: -2px;">
										<div class="popup_view_name_text_2">
											已认证
										</div>
									</div>
								</div>
								<div class="popup_view_message flex align-center justify-between">
									<div class="" style="width: 40%;">
										<div class="">
											手机号
										</div>
										<div class="">
											{{ userInfo.phone }}
										</div>
									</div>
									<div class="" style="width: 60%;">
										<div class="">
											身份证
										</div>
										<div class="">
											{{ meetingUserInfo.idCard }}
										</div>
									</div>
								</div>
							</div>
							<div slot="reference" class="">
								<div class="flex align-center title_text">
									<i class="el-icon-check"
										style="margin-right: 5px;font-size: 18px;font-weight: bold;"></i>
									已实名认证（{{meetingUserInfo.name}}）
								</div>
							</div>
						</el-popover>
					</div>


				</div>



				<!-- <div class="line-list">
                    <ul>
                        <li
                            v-for="(item, index) in lineList"
                            :key="index"
                            title="点击切换线路"
                            :class="currentIndex == index ? 'active' : ''"
                            @click="handleLineClick(item, index)"
                        >
                            {{ item.name }}
                        </li>
                    </ul>
                </div> -->
				<div class="liveStream">
					<!-- {{lineList}} -->
					<!-- 根据状态,设置对应的图片 poster="../../assets/img/successful-test.png" -->
					<!-- <video ref="videoElement" :poster="
					meetingInfo.state == 'ONGOING'
					    ? '../../assets/img/NOT_STARTED.png'
					    : meetingInfo.state == 'NOT_STARTED'
					      ? '../../assets/img/NOT_STARTED.png'
					      : meetingInfo.state == 'TESTING'
					        ? '../../assets/img/TESTING.png'
					        : '../../assets/img/END.png'
					" controls autoplay class="video"></video> -->
					<!-- <video v-if="lineList.usingStream.type == 'ONGOING'" ref="videoElement"
						poster="../../assets/img/NOT_STARTED.png" controls autoplay class="video"></video>
					<video v-else-if="meetingInfo.state == 'NOT_STARTED'" ref="videoElement"
						poster="../../assets/img/NOT_STARTED.png" controls autoplay class="video"></video>
					<video v-else-if="meetingInfo.state == 'TESTING'" ref="videoElement"
						poster="../../assets/img/END.png" controls autoplay class="video"></video>
					<video v-else ref="videoElement" poster="../../assets/img/NOT_STARTED.png" controls autoplay
						class="video"></video> -->
					<!-- {{lineList.usingStream.flvPullUrl}} -->
					<video v-if="lineList.usingStream === undefined" ref="videoElement" controls autoplay
						class="video"></video>
					<video v-else-if="lineList.usingStream.type ==='ONGOING'" ref="videoElement"
						:poster="lineList.usingStream.flvPullUrl" controls autoplay class="video"></video>
					<video v-else-if="lineList.usingStream.type ==='VOD'" :src="lineList.usingStream.flvPullUrl"
						controls autoplay class="video"></video>
					<div v-else-if="lineList.usingStream.type!=''" class="video">
						<img style="width: 100%;height: 100%;" :src="lineList.usingStream.flvPullUrl" alt="">
					</div>
					<video v-else ref="videoElement" :poster="lineList.usingStream.flvPullUrl" controls autoplay
						class="video"></video>

					<!-- <video v-else ref="videoElement"
							:poster="lineList.usingStream.flvPullUrl" controls autoplay class="video"></video> -->

					<!-- <video ref="videoElement" controls autoplay class="video"></video> -->
					<div class="tabs">
						<el-tabs v-model="activeName" @tab-click="handleClick" :stretch="true">
							<el-tab-pane label="投票表决" name="first">
								<div :class="voteList.length>7?'scrollBarShow':'scrollBarHide'" style="height: 484px;">
									<div class="file-list" v-if="voteList.length > 0">
										<ul>
											<li class="file-list-item" v-for="(item, index) in voteList" :key="index"
												@click="openVote(item.id, item.subjectId, item.status)">
												<div class="coTtent">
													{{ item.name }}
													<!-- <router-link
									                    :title="item.name"
									                    :to="{ path: '/voting', query: { id: item.id, meetingId: item.subjectId } }"
									                    ></router-link
									                > -->
												</div>
												<div class="mark" style="">
													<div class="flex align-center justify-end"
														style="font-size: 14px;font-weight: 400;padding-right: 3%;"
														:style="item.status === 0
														            ? 'color: #CCCCCC;'
														            : item.status === 1
														                ? 'color: #74798C;'
														                : item.status === -1
														                    ? 'color: #FF8D1A;'
														                    : 'color: #00C800;'">
														<!-- item.status === 0||item.status === 1?'el-icon-circle-check':'el-icon-time'" -->
														<i :class="item.status === 0
														            ? 'el-icon-zhongzhi'
														            : item.status === 1
														                ? 'el-icon-circle-check'
														                : item.status === -1
														                    ? 'el-icon-time'
														                    : 'el-icon-kaishi'" style="font-size: 18px;margin-right: 5px;"></i>
														{{
														        item.status === 0
														            ? '已结束'
														            : item.status === 1
														                ? '已表决'
														                : item.status === -1
														                    ? '未开始'
														                    : '进行中'
														}}
													</div>

													<!-- <el-tag effect="dark"
														:type="item.status === 2 ? 'success' : item.status === -1 ? 'warning' : 'info'">
														{{
									                            item.status === 0
									                                ? '已结束'
									                                : item.status === 1
									                                    ? '已表决'
									                                    : item.status === -1
									                                        ? '未开始'
									                                        : '进行中'
									                    }}
													</el-tag> -->
													<!-- <router-link
									                    :title="item.name"
									                    :to="{ path: '/voting', query: { id: item.id, meetingId: item.subjectId } }"
									                ></router-link> -->
												</div>
											</li>
										</ul>
									</div>
									<div class="noData" v-else>
										<div class="">
											<div class="flex align-center justify-center">
												<i class="iconfont icon-meiyoushuju"></i>
											</div>

											<p>暂无数据</p>
										</div>
									</div>
								</div>


							</el-tab-pane>
							<el-tab-pane label="文件列表" name="second">
								<!-- -webkit-overflow-scrolling: touch; -->
								<div class="" :class="fileList.length>7?'scrollBarShow':'scrollBarHide'"
									style="height: 484px;">
									<div v-if="fileList.length>0" class="file-list">
										<ul>
											<li title="点击下载" v-for="(item, index) in fileList" :key="index"
												class="file-list-item" style="padding-right: 3%;">
												<div class="coTtent file-item" @click="dialogVisibleImageClick(item.docId, item.name)" :title="item.name">{{ item.name }}</div>
												<i class="el-icon-xiazai" v-if="!meetingInfo.banDownload" @click="downloadFile(item.docId, item.name)" style="color: #2766FF;"></i>
											</li>
										</ul>
									</div>
									<div class="noData" v-else>
										<div class="">
											<div class="flex align-center justify-center">
												<i class="iconfont icon-meiyoushuju"></i>
											</div>

											<p>暂无数据</p>
										</div>
									</div>
								</div>
							</el-tab-pane>
							<!-- <el-tab-pane label="基本信息" name="third">
                                <div class="file-list">
                                    <ul>
                                        <li class="file-list-item">
                                            <div class="coTtent">案号：{{ meetingInfo.subject }}</div>
                                        </li>
                                        <li class="file-list-item">
                                            <div class="coTtent">会议名称：{{ meetingInfo.name }}</div>
                                        </li>
                                        <li class="file-list-item">
                                            <div class="coTtent">会议时间：{{ timeConvert(meetingInfo.startTime) }}</div>
                                        </li>
                                        <li class="file-list-item" v-if="meetingUserInfo.name">
                                            <div class="coTtent">姓名：{{ meetingUserInfo.name }}</div>
                                        </li>
                                        <li class="file-list-item" v-if="meetingUserInfo.idCard">
                                            <div class="coTtent">身份证：{{ meetingUserInfo.idCard }}</div>
                                        </li>
                                    </ul>
                                </div>
                            </el-tab-pane> -->
						</el-tabs>
					</div>
					<Vote v-if="voteDialogVisible" :voteId="voteId" :meetingId="voteMeetingId" :status='status'
						:voteDialogVisible="voteDialogVisible" @close="closeVote" />
				</div>
				<!-- 视频字幕 -->
				<div class="meeting-toast">
					<div>
						会议提示:{{ lineList.liveName }}
					</div>
				</div>

			</div>
			<div v-if="meetingInfo.question" class="" style="height: 16px;width: 100%;background-color: #F3F4F6;">

			</div>
			<div v-if="meetingInfo.question" class="">
				<div class="flex align-center justify-between" style="width: 100%;height: 400px;">
					<div class="" style="width: 70%;height:100%;border: 1px solid #F0F0F0;">
						<div class="flex align-center"
							style="height: 50px;border-bottom: 1px solid #F0F0F0;padding-left: 20px;font-size: 14px;color: #000000;padding-right: 20px;">
							<div class="flex align-center justify-between" style="width: 100%;">
								<div class="">
									我的提问
								</div>
								<div class="flex align-center">
									<div class=""
										style="font-size: 14px;font-weight: 400;color: #FF5733;margin-right: 16px;">
										刷新查看管理员回复内容
									</div>
									<el-button icon="el-icon-refresh-right" @click="getMyQuestion">刷新</el-button>
								</div>
							</div>
						</div>
						<div class=""
							style="height: 100%;background-color: #FAFBFD;font-size: 14px;font-family: Source Han Sans CN-Regular, Source Han Sans CN;font-weight: 400;color: #282D30;line-height: 20px;">
							<div class="" style="overflow-y: scroll;height: 87.5%;width: 100%;">
								<div class="" style="padding: 10px;">
									<div class="" v-for="(item, index) in questionList" :key="index">
										<div class="" style="margin-bottom: 20px;word-wrap: break-word;">
											<span style="color: #808080;">我：</span> {{ item.content }}
										</div>
										<div class="" style="margin-bottom: 20px;word-wrap: break-word;"
											v-for="(item1,indexs) in item.replyList" key="indexs">
											<span style="color: #808080;">管理员：</span>{{item1.content}}
										</div>
									</div>
									<div class="noData" v-if="questionList.length=='0'">
										<div class="">
											<div class="flex align-center justify-center" style="margin-bottom: 20px;">
												<i class="iconfont icon-meiyoushuju"></i>
											</div>

											<p>暂无数据</p>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="" style="width: 30%;height: 100%;border: 1px solid #F0F0F0;">
						<div class="flex align-center"
							style="height: 50px;padding-left: 20px;font-size: 14px;color: #000000;">
							发起提问
						</div>
						<div class="" style="padding: 0px 10px;">
							<div class="">
								<textarea
									style="width: 95%;height: 120px;max-width: 95%;min-width: 95%;padding: 5px;border: 1px solid #E0E0E0;"
									placeholder="可以向现场的管理人及债务人发起提问" v-model="textarea"></textarea>
							</div>
							<div class="flex justify-end" style="padding-right: 10px;margin-top: 16px;">
								<el-button style="width: 120px;" type="primary" @click="submit">提 交</el-button>
							</div>
						</div>
					</div>
				</div>


				<!-- 提问 -->
				<!-- <div class="put-question">
					<el-tabs v-model="subActiveName" @tab-click="handleSubClick">
						<el-tab-pane name="first">
							<span slot="label" :style="{ color: subActiveName == 'first' ? '#2766FF' : '#000' }">
								发起提问</span>
							<h6>你可以向现场的管理人及债务人发起提问</h6>
							<el-input type="textarea" :rows="5" placeholder="在这里写上你的疑惑吧" v-model="textarea"> </el-input>
							<el-button type="primary" @click="submit">提交</el-button>
						</el-tab-pane>
						<el-tab-pane name="second">
							<span slot="label" :style="{ color: subActiveName == 'second' ? '#2766FF' : '#000' }">
								我的提问</span>
							<ul class="question-list">
								<li v-for="(item, index) in questionList" :key="index">
									<div class="subTitle">
										<span>提问时间:</span><time>{{ timeConvert(item.createTime) }}</time>
									</div>
									<p>
										<span>提问内容:</span>
										{{ item.content }}
									</p>
								</li>
							</ul>
						</el-tab-pane>
					</el-tabs>
				</div> -->
			</div>
		</el-card>
		<!-- <Footer /> -->
		 <PdfPreview v-if="dialogVisibleImage" :dialogVisibleImage="dialogVisibleImage" :dialogImageUrl="dialogImageUrl" :previewType="previewType" @close="dialogVisibleImage = false"></PdfPreview>
	</div>
</template>

<script>
	import Footer from '@/components/layout/Footer';
	import PdfPreview from '@/components/pdf-preview.vue';
	import flvjs from 'flv.js';
	import global from 'global';
	import moment from 'moment';
	import axios from 'axios';
	import {
		getMeetingFiles,
		getUserGrouping,
		getVotingRecords,
		getVotingRecordsMeetingId
	} from '@/serve/userGrouping';
	import {
		getUserSign,
		setUserSign
	} from '@/serve/sign';
	import {
		getMyQuestion,
		addQuestion
	} from '@/serve/question';
	import {
		mapState
	} from 'vuex';
	import {
		setInterval
	} from 'timers';
	import Vote from '../meetingManages/components/vote/index';
	import {
		getMeetingDetail,
	} from '@/serve/meeting';
	import {
		gatheringMeetingAuth
	} from '@/serve/live';

	export default {
		data() {
			return {
				subtitles: '', //视频字幕
				currentIndex: 0,
				isTimer: null,
				timer: null,
				flvPlayer: null,
				liveUrl: '',
				meetingName: '',
				activeName: 'first',
				subActiveName: 'first',
				textarea: '',
				meetingId: '',
				fileList: [],
				voteList: [],
				groupIds: [],
				isFlag: false,
				questionList: [],
				lineList: {
					usingStreamId: '',
				}, // 线路配置信息
				voteRecords: {}, // 用户表决过的记录
				voteDialogVisible: false,
				voteId: '',
				voteMeetingId: '',
				status: 10,
				meetingInfo: {},
				meetingUserInfo: {},
				previousTab: '',
				userInfo: {},
				dialogImageUrl:'',
				dialogVisibleImage:false,
				previewType:'',
			};
		},
		components: {
			Footer,
			Vote,
			PdfPreview
		},
		computed: {
			// ...mapState({
			// 	userInfo: state => state.user.userInfo
			// }),
			actions() {
				return global.file.url;
			}
		}, 
		async created() {
			// this.liveUrl = this.$route.query.url;
			this.meetingName = this.$route.query.name;
			this.meetingId = this.$route.query.id;
			console.log("meetingName:", this.meetingName)
			console.log("meetingId:", this.meetingId)
			// this.activeName = this.$route.query.activeName;
			this.previousTab = this.$route.query.tab;
			// getMeetingDetail(this.meetingId).then(res => {
			// 	this.meetingInfo = res
			// })
			console.log("window.sessionStorage.getItem('ms_userInfo')", )
			if (JSON.parse(window.sessionStorage.getItem('ms_userInfo')).type != 'ADMIN') {
				await getUserSign(this.meetingId)
					.then((res) => {
						this.userInfo = res
					});
				if (JSON.parse(window.sessionStorage.getItem('ms_userInfo')).type != 'ADMIN' && JSON.parse(window
						.sessionStorage.getItem('ms_userInfo')).type != 'MANAGER'&& JSON.parse(window
						.sessionStorage.getItem('ms_userInfo')).type != 'OTHER') {
					this.getVotingRecords();
				}

				await this.getUserGrouping();
			} else {
				this.getCacheData();
			}
			gatheringMeetingAuth({
				meeting_id: this.meetingId,
				isPc: true
			}).then(res => {
				this.meetingUserInfo = res || {}
			})
			// this.meetingId

			this.getMeetingFiles();
			this.getMyQuestion();


			await this.getVoteList();
			await this.getRealLiveConfig();
			await this.getMeetingDetail();

		},
		mounted() {},
		beforeDestroy() {
			this.flvPlayer.destroy();
			this.isFlag = true;
			this.isTimer && window.clearInterval(this.isTimer);
			this.isTimer = null;
		},
		watch: {
			// 当监听到线路切换时，就改变线路地址
			'lineList.usingStreamId'(newVal, oldVal) {
				if (newVal != oldVal && oldVal) {
					this.destroyVideo();
					this.liveUrl = this.lineList.usingStream.flvPullUrl;
					this.setLivePath();
				}
			}
		},
		methods: {
			async getMeetingDetail() {
				await getMeetingDetail(this.meetingId).then(res => {
					this.meetingInfo = res
				})
			},
			disposePoster(type) {
				let tu = '';
				if (type === 'ONGOING') {
					tu = '../../assets/img/NOT_STARTED.png';
				} else if (type === 'NOT_STARTED') {
					tu = '../../assets/img/NOT_STARTED.png';
				} else if (type === 'TESTING') {
					tu = '../../assets/img/TESTING.png';
				} else {
					tu = '../../assets/img/END.png';
				}
				return tu;
			},
			goBack() {
				this.isTimer && window.clearInterval(this.isTimer);
				this.isTimer = null;
				this.$router.push({
					path: '/meetingManages',
					query: {
						tab: this.previousTab,
					}
				});
			},
			handleClick(tab, event) {
				if (tab.name === 'first') {
					// 初始化处理
				} else {
					this.getMeetingFiles();
				}
			},
			handleSubClick(tab, event) {
				if (tab.name === 'second') {
					this.getMyQuestion();
				} else {

				}
			},
			// 销毁原播放器
			destroyVideo() {
				this.flvPlayer.pause();
				this.flvPlayer.unload();
				this.flvPlayer.detachMediaElement();
				this.flvPlayer.destroy();
				this.flvPlayer = null;
			},
			// 直播路径设置
			setLivePath() {
				if (flvjs.isSupported()) {
					this.$nextTick(() => {
						try {
							this.flvPlayer = flvjs.createPlayer({
								type: 'flv',
								isLive: true,
								hasAudio: true,
								url: this.liveUrl,
							});
							// console.log('xxx', this.flvPlayer);
							this.flvPlayer.attachMediaElement(this.$refs.videoElement);
							this.flvPlayer.load();
							this.flvPlayer.play();
						} catch (err) {
							console.log(err);
						}
					});
				}
			},
			// 时间格式化
			timeConvert(timestamp) {
				return moment(timestamp).format('YYYY-MM-DD HH:mm:ss');
			},
			// 获取我的问题
			getMyQuestion() {
				getMyQuestion(this.meetingId, {
						page: 0,
						rows: 1000
					})
					.then(res => {
						this.questionList = res;
					})
					.catch(err => {
						this.$message.error(err.data.message);
					});
			},
			submit() {
				if (!this.textarea.trim()) {
					return this.$message.warning('提问内容不能为空！');
				}
				addQuestion(this.meetingId, {
						content: this.textarea
					})
					.then(() => {
						this.textarea = '';
						this.$notify({
							title: '提问成功',
							type: 'success',
							duration: 3000
						});
						this.getMyQuestion();
					})
					.catch(err => {
						this.$message.error(err.data.message);
					});
			},
			// 获取人员组别
			async getUserGrouping() {
				let userId = JSON.parse(window.sessionStorage.getItem('ms_userInfo')).id;
				await getUserGrouping(this.meetingId, userId)
					.then(res => {
						this.groupIds = res.map(item => item.groupId);
						this.getCacheData();
					})
					.catch(err => {
						this.$message.error(err.data.message);
					});
			},
			// 下载文件
			downloadFile(id, name) {
				const href = `/api/sys/fs/${id}?d=1`;
				const a = document.createElement('a');
				a.setAttribute('href', href);
				a.setAttribute('download', name);
				document.body.appendChild(a);
				a.click();
				document.body.removeChild(a);
			},
			// 获取会议文件列表
			getMeetingFiles() {
				getMeetingFiles(this.meetingId, {
						excludeVideo: false,
						page: 0,
						rows: 100
					})
					.then(res => {
						console.log("getMeetingFiles", res)
						this.fileList = res;
					})
					.catch(err => {
						this.$message.error(err.data.message);
					});
			},
			// 获取用户在当前会议下的投票记录
			async getVotingRecords() {
				await getVotingRecords({
						meeting_id: this.meetingId,
						user_id: this.userInfo.userId
					})
					.then(res => {
						this.voteRecords = res;
						console.log("res", res)
						this.getUserGrouping();
					})
					.catch(err => {
						this.$message.error(err.data.message);
					});
			},
			// 用户之前是否表决过
			isVoteRecord(item) {
				return !!this.voteRecords[item.id];
			},
			// 同步缓存
			isSyncFlag(item) {
				let synchronizationVote = JSON.parse(window.localStorage.getItem('synchronizationVote'));
				if (synchronizationVote && Array.isArray(synchronizationVote)) {
					return synchronizationVote.includes(item.id);
				} else {
					return false;
				}
			},
			// 点击切换线路
			/*  handleLineClick(item, index) {
			    this.currentIndex = index;
			    this.liveUrl = item.flvPullUrl;
			    this.destroyVideo();
			    this.setLivePath();
			}, */
			// 实时获取直播配置
			async getRealLiveConfig(isFlag = false) {
				await axios
					// .get(`https://api.pochanyun.com/cache/court-live/lives/${this.meetingId}.json`)
					// .get(`https://live.pochanyun.net/cache/court-live/lives/${this.meetingId}.json`)
					.get(`/cache/court-live/lives/${this.meetingId}.json`)
					.then(res => {
						// 初始化使用
						if (isFlag) {
							this.lineList = res.data;
							this.liveUrl = this.lineList.usingStream.flvPullUrl;
							this.setLivePath();
						} else {
							if (res.data.usingStreamId == this.lineList.usingStreamId) {
								this.lineList = res.data;
							} else {
								this.lineList = res.data;
								this.liveUrl = this.lineList.usingStream.flvPullUrl;
								this.setLivePath();
							}

						}
					})
					.catch(err => {
						this.$message.error(err.data.message);
					});
			},
			getCacheData() {
				if (!this.isTimer) {
					this.isTimer = window.setInterval(() => {
						if (JSON.parse(window.sessionStorage.getItem('ms_userInfo')).type != 'ADMIN' && JSON.parse(
								window
								.sessionStorage.getItem('ms_userInfo')).type != 'MANAGER'&& JSON.parse(
								window
								.sessionStorage.getItem('ms_userInfo')).type != 'OTHER') {
							this.getVotingRecords();
						}
						this.getVoteList();
						this.getRealLiveConfig();
						this.getMeetingDetail();
					}, 3000);
				}
			},
			//实时获取投票表决项
			async getVoteList() {
				if (this.isFlag) return;
				let userId = JSON.parse(window.sessionStorage.getItem('ms_userInfo')).id;
				// 后面做成可配置
				await axios
					// .get(`https://api.pochanyun.com/cache/court-live/votes/${this.meetingId}.json?v=${Math.random().toString().slice(2, 14)}`)
					// .get(`https://live.pochanyun.net/cache/court-live/votes/${this.meetingId}.json?v=${Math.random().toString().slice(2, 14)}`)
					.get(`/cache/court-live/votes/${this.meetingId}.json?v=${Math.random().toString().slice(2, 14)}`)
					.then(async res => {
						let conduct = [],
							voted = [],
							end = [],
							arr = [],
							notStarted = [];
						const userObj = this.userInfo.agent ? await getVotingRecordsMeetingId({
							meetingId: this.meetingId
						}) : {}

						// 表决状态筛选
						res.data.forEach(item => {

							const isAllVoted = this.userInfo.agent ? (userObj[item.id] || [])
								.every(item => item.isVoted) : true;
							// console.log("item",item)
							console.log("ss", this.isVoteRecord(item))

							if (!item.began) {
								// 未开始 - 后端校验
								item.status = -1;
								notStarted.push(item);
							} else if (item.ended) {
								// 已结束 - 前端校验
								item.status = 0;
								end.push(item);
								// || this.isSyncFlag(item)
							} else if (isAllVoted && (this.isVoteRecord(item))) {
								// 已表决
								item.status = 1;
								voted.push(item);
							} else {
								// 进行中
								item.status = 2;
								conduct.push(item);
							}
						});
						let voteList = [...notStarted, ...conduct, ...voted, ...end];
						voteList.forEach(item => {
							item.groupIds = item.groups.map(citem => citem.groupId);
							item[item.id] = true;
						});
						for (let i = 0; i < voteList.length; i++) {
							two: for (let j = 0; j < this.groupIds.length; j++) {
								if (voteList[i].groupIds.indexOf(this.groupIds[j]) > -1) {
									arr.push(voteList[i]);
									break two;
								}
							}
						}
						this.voteList = arr;
						console.log("voteList",this.voteList);
					})
					.catch(err => {
						console.log(err);

					});
			},
			openVote(id, subjectId, status) {
				if (status !== -1) {
					getUserSign(this.meetingInfo.id)
						.then((res) => {
							if (!res.sign) {
								setUserSign(this.meetingInfo.id);
								// setTestSign(this.meetingInfo.id);
							}
							this.userInfo = res
						});

					this.voteId = id;
					this.voteMeetingId = subjectId;
					this.voteDialogVisible = true;
					this.status = status
				} else {
					this.$message.error('表决还未开始！');
				}
			},
			async closeVote() {
				if (JSON.parse(window.sessionStorage.getItem('ms_userInfo')).type != 'ADMIN' && JSON.parse(window
						.sessionStorage.getItem('ms_userInfo')).type != 'MANAGER'&& JSON.parse(window
						.sessionStorage.getItem('ms_userInfo')).type != 'OTHER') {
					await this.getVotingRecords()
				}

				await this.getVoteList()
				await this.getRealLiveConfig()
				await this.getMeetingDetail()
				// await this.getVoteList();
				// await this.getRealLiveConfig();
				// await this.getMeetingDetail();
				this.voteId = '';
				this.voteMeetingId = '';
				this.voteDialogVisible = false;
				this.status = 10;
				// 结束定时任务，重启定时任务。
				this.isTimer && window.clearInterval(this.isTimer);
				this.isTimer = null;
				this.getCacheData();
				console.log("jinr")

			},
			dialogVisibleImageClick(id, name) {
				/**升级正式环境时需更换正式域名 */
				/**升级正式环境时需更换正式域名 */
				/**升级正式环境时需更换正式域名 */
				const href =`/api/sys/fs` + `/${id}`;
				// const href = `https://live.pochanyun.net/api/sys/fs` + `/${id}`;
				this.dialogImageUrl = href;
				this.previewType = '';

				if (name.indexOf('.jpg') != -1 || name.indexOf('.png') != -1 || name.indexOf('.jpeg') != -1 || name
					.indexOf('.pdf') != -1 || name.indexOf('.PDF') != -1) {
					this.previewType = name;
					this.dialogVisibleImage = true;
				} else {
					this.$message({
						message: '该文件类型不支持预览',
						type: 'warning'
					});
				}
			},
		}
	};
</script>
<style>
	.el-popover.menu-popover {
		padding: 0px !important;
		background: #fffFFF00;
		border: 0px;
	}
</style>
<style scoped lang="scss">
	::v-deep .wrapper::-webkit-scrollbar {
		width: 10px !important;
		/*高宽分别对应横竖滚动条的尺寸*/
		height: 10px !important;
	}

	.scrollBarShow {
		overflow-y: scroll;
		-webkit-overflow-scrolling: touch;
	}

	.scrollBarHide {
		overflow-y: scroll;
	}

	.scrollBarHide::-webkit-scrollbar {
		display: none
	}

	::v-deep .content {
		overflow-y: scroll !important;
	}

	::v-deep .content::-webkit-scrollbar {
		/* /隐藏滚轮/ */
		display: scroll !important;
	}

	::v-deep .el-tabs__nav.is-stretch {
		height: 50px;
		align-items: center;
	}

	::v-deep .el-tabs__active-bar.is-top {
		padding: 0 20px;
		box-sizing: border-box;
		background-clip: content-box;
	}

	::v-deep .el-tabs__active-bar.is-top {
		background: #2766FF;
	}

	::v-deep .el-tabs__active-bar.is-top {
		background-color: #F2F2F200;
	}

	::v-deep .el-tabs__active-bar.is-top::before {
		content: '';
		display: block;
		background: #2766FF;
		height: 2px;
		width: 90px;
		margin: auto;
	}

	::v-deep .el-tabs__nav-scroll {
		// padding-left: 15px;
		box-sizing: border-box;

	}

	.el-page-header {
		background: #fff;
		padding: 15px;
	}

	.popup_view {
		// background-image: url("../../static/personal-bg2.png");
		// background-size: 100%;
		width: 335px;
		height: 160px;
		position: relative;
		overflow: hidden;
	}

	.popup_view_name {
		position: absolute;
		top: 18px;
		width: 100%;
		// padding: 0px 12px;
	}

	.popup_view_name_text_1 {
		padding-left: 15px;
		font-size: 24px;
		font-family: Source Han Sans CN-Medium, Source Han Sans CN;
		font-weight: 400;
		color: #191E24;
		line-height: 28px;
	}

	.popup_view_name_text_2 {
		font-size: 16px;
		font-family: Source Han Sans CN-Regular, Source Han Sans CN;
		font-weight: 400;
		color: #FFFFFF;
		line-height: 24px;
	}

	.popup_view_message {
		position: absolute;
		bottom: 17px;
		width: 100%;
		padding: 0px 15px;
		font-size: 16px;
		font-family: Source Han Sans CN-Regular, Source Han Sans CN;
		font-weight: 400;
		color: #191E24;
		line-height: 24px;
	}

	// ::v-deep .el-tabs__active-bar {
	//     // display: none;
	//     left: 50%;	
	//     // margin-left: -123px;
	// }

	// ::v-deep.el-tabs__item {
	//     color: #74798C;
	// }

	// ::v-deep.el-tabs__item.is-active {
	//     color: #2766FF;
	// }

	::v-deep.el-tabs__header {
		background: #FAFBFD;
		border: 1px solid #F2F2F2;
		margin: 0px;
		// padding: 10px;
	}

	::v-deep .el-card__body {
		padding: 0px;
	}

	::v-deep .el-card {
		border: 0px;
	}

	.noData {
		height: 300px;
		display: flex;
		justify-content: center;
		align-items: center;
		color: #000000;

		i {
			font-size: 40px;
		}

		p {
			font-size: 15px;
		}
	}

	.box-card {
		// width: 1590px;
		width: 1280px;
		// padding-bottom: 100px;
		margin-top: 10px;
		// margin-bottom: 20px;

		.live-container {
			margin: auto;
			position: relative;

			padding: 16px 0px 16px 16px;

			.title {
				padding: 10px 0;
				font-size: 18px;
				font-family: HarmonyOS Sans SC-Medium, HarmonyOS Sans SC;
				font-weight: bold;
				color: #000000;
				line-height: 22px;
				margin-bottom: 10px;
			}

			.title_text {
				font-size: 16px;
				font-family: Source Han Sans CN-Regular, Source Han Sans CN;
				font-weight: bold;
				color: #009944;
				line-height: 20px;
			}

			.line-list {
				ul {
					margin: 10px 0;
					list-style: none;
					display: flex;
					justify-content: flex-start;
					align-items: center;

					li {
						font-size: 18px;
						color: #8e7f7f;
						border: 2px solid #8e7f7f;
						margin-right: 15px;
						padding: 3px 16px;
						border-radius: 30px;

						&.active {
							border: 2px solid #c22929;
							color: #c22929;
						}

						&:hover {
							cursor: pointer;
						}
					}
				}
			}

			.meeting-toast {
				margin: 10px 0;
				font-size: 14px;
				font-family: Source Han Sans CN-Regular, Source Han Sans CN;
				font-weight: 400;
				color: #FF5733;
				line-height: 20px;

				span {
					margin-right: 10px;
					font-weight: bold;
				}
			}

			.put-question {

				// margin: 20px 10%;
				h6 {
					color: #b1b3b2;
					font-weight: normal;
					font-size: 14px;
				}

				::v-deep .el-textarea {
					margin: 15px 0;
					font-size: 14px;
				}

				.question-list {
					li {
						margin-bottom: 20px;
						background: #f5f5f6;
						padding: 10px 15px;

						font-size: 14px;
						font-family: Source Han Sans CN-Regular, Source Han Sans CN;
						font-weight: 400;
						color: #282D30;


						// span {
						// 	margin-right: 10px;
						// 	font-size: 15px;
						// 	font-weight: bolder;
						// }

						// .subTitle {
						// 	display: flex;
						// 	justify-content: flex-start;
						// 	align-items: center;

						// 	time {
						// 		font-size: 15px;
						// 	}
						// }

						// p {
						// 	line-height: 23px;
						// 	font-size: 15px;
						// 	margin-top: 10px;
						// }
					}
				}
			}

			.iconfont {
				font-size: 23px;
			}

			.liveStream {
				height: 550px;
				display: flex;

				.video {
					width: 70%;
					height: 100%;
					background-color: #000000 !important;
					// object-fit: cover;
					// border: 1px solid #413b41;
				}

				// .img{
				// 	width: 70%;
				// 	height: 100%;
				// 	background-color: #FFFFFF;
				// 	object-fit: cover;
				// }

				.tabs {
					width: 30%;
					height: 100%;
					background: #FFFFFF;
					// overflow-y: scroll;

					.file-list {

						// overflow-y: scroll;
						ul {
							height: 100%;

							.file-list-item {
								height: 60px;
								color: #000000;
								display: flex;
								justify-content: space-around;
								align-items: center;
								padding: 0 10px 0 10px;
								box-sizing: border-box;
								cursor: pointer;

								.file-item {
									&:hover {
										text-decoration: underline;
									}
								}

								.coTtent {
									font-size: 15px;
									flex: 3;
									padding: 0 0 0 3%;
									overflow: hidden;
									text-overflow: ellipsis;
									display: -webkit-box;
									-webkit-line-clamp: 2;
									-webkit-box-orient: vertical;

									a {
										color: #000000;
										display: block;

										&:hover {
											text-decoration: underline;
										}

										&.disabled {
											color: #909399;
											pointer-events: none;

											&:hover {
												text-decoration: none;
											}
										}
									}
								}

								.mark {
									flex: 1;
									text-align: right;
								}
							}
						}
					}


				}

				::v-deep .el-tabs__nav-wrap::after {
					display: none;
				}

				::v-deep .el-tabs__nav {
					// width: 100%;
					// text-align: center;

					::v-deep .el-tabs__item {
						color: #9c9398;
						box-sizing: border-box;
						padding: 0 4%;
						font-size: 18px;

						&.is-active {
							// color: #fff;
							// font-weight: bolder;
							// border-bottom: 2px solid #c22929;
						}
					}
				}
			}
		}
	}
</style>